import { Box, styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const ProfileListMeContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '10px',
}));

export const ProfileImageContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? COLORS.DARK : COLORS.WHITE,
  borderRadius: '6px',
  padding: ' 3.6px 3.2px 3.6px 3.6px',
  aspectRatio: '3/4',
  width: '90px',
  height: '120px',
  border: `1px solid ${COLORS.PRIMARY}`,
}));

export const ProfileImage = styled('img')(({ theme }) => ({
  width: '100%',
  borderRadius: '4px',
  height: '100%',
  objectFit: 'cover',
}));
